/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Segment, Divider, Checkbox, Dimmer,
  Icon, Popup, Table, Button, Grid,
  Message, MessageHeader, Modal, Header
} from "semantic-ui-react";
import UpdateLoader from "./UpdateLoader";

import { withRouter } from "react-router-dom";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class DevicesChannels extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isDeviceChannelsOn: false,
      // Verificar mestre
      checkMaster: false,
      // lista de devices
      devices: [],
      // sorting
      column: null,
      sortDirection: "ascending",
      isColumnClicked: false,
      // Confirmação de alteração e loader
      changeType: "",
      isModalOpen: false,
      isUpdateLoaderDimmerActive: false,
      modalHeader: "",
      modalText1: "",
      modalText2: "",
      updateStatus: Constants.NOT_UPDATING,
    };
    // Loader ref
    this.updateLoaderRef = React.createRef();
  }

  showModal = (modalHeader, modalText1, modalText2) => {
    let changeType = "";

    if (modalHeader === Strings.MANUAL_CHANNEL_SELECTION) {
      changeType = Constants.MANUAL_CHANNEL;
    }
    else if (modalHeader === Strings.CHECK_MASTER_2) {
      changeType = Constants.VERIFY_MASTER;
    }
    else {
      changeType = Constants.DEV_CHANNELS;
    }

    this.setState({
      isModalOpen: true,
      changeType: changeType,
      modalHeader: modalHeader,
      modalText1: modalText1,
      modalText2: modalText2
    });
  }

  hideModal = () => this.setState({ isModalOpen: false });

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "devicesPerChannel", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch((error) => {
          console.log(error);
          return {
            "channel1": [],
            "channel2": [],
            "channel3": [],
            "channel4": [],
            "channel5": []
          };
        })
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "devicesPerChannelOn", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data.isOn)
        .catch((error) => {
          console.log(error);
          return false;
        })
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "verificarMestreDoSegmento", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data.checkMaster)
        .catch((error) => {
          console.log(error);
          return false;
        })
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "devicesMonitorPB", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch((error) => {
          console.log(error);
          return [];
        })
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      devices: this.convertDevices(resolvedPromisses[3], resolvedPromisses[0]),
      isDeviceChannelsOn: resolvedPromisses[1],
      checkMaster: resolvedPromisses[2]
    });
  }

  convertDevices = (devicesList, channels) => {
    let devices = [];

    for (let i = 0; i < devicesList.length; i++) {
      devices.push(this.getDevice(channels, devicesList[i]));
    }

    devices.sort(UtilsInstance.sortBy("address", false, function (a) { return a; }));

    console.log(devices);

    return devices;
  }

  getDevice = (channels, devicePB) => {
    let device = {};
    let deviceFound = false;

    for (let i = 0; i < channels.channel1.length; i++) {
      if (devicePB.address == channels.channel1[i]) {
        deviceFound = true;
        device = {
          "address": channels.channel1[i],
          "isMaster": devicePB.isMaster,
          "channel1": true,
          "channel2": false,
          "channel3": false,
          "channel4": false,
          "channel5": false
        };
        break;
      }
    }

    if (!deviceFound) {
      for (let i = 0; i < channels.channel2.length; i++) {
        if (devicePB.address == channels.channel2[i]) {
          deviceFound = true;
          device = {
            "address": channels.channel2[i],
            "isMaster": devicePB.isMaster,
            "channel1": false,
            "channel2": true,
            "channel3": false,
            "channel4": false,
            "channel5": false
          };
          break;
        }
      }
    }

    if (!deviceFound) {
      for (let i = 0; i < channels.channel3.length; i++) {
        if (devicePB.address == channels.channel3[i]) {
          deviceFound = true;
          device = {
            "address": channels.channel3[i],
            "isMaster": devicePB.isMaster,
            "channel1": false,
            "channel2": false,
            "channel3": true,
            "channel4": false,
            "channel5": false
          };
          break;
        }
      }
    }

    if (!deviceFound) {
      for (let i = 0; i < channels.channel4.length; i++) {
        if (devicePB.address == channels.channel4[i]) {
          deviceFound = true;
          device = {
            "address": channels.channel4[i],
            "isMaster": devicePB.isMaster,
            "channel1": false,
            "channel2": false,
            "channel3": false,
            "channel4": true,
            "channel5": false
          };
          break;
        }
      }
    }

    if (!deviceFound) {
      for (let i = 0; i < channels.channel5.length; i++) {
        if (devicePB.address == channels.channel5[i]) {
          deviceFound = true;
          device = {
            "address": channels.channel5[i],
            "isMaster": devicePB.isMaster,
            "channel1": false,
            "channel2": false,
            "channel3": false,
            "channel4": false,
            "channel5": true
          };
          break;
        }
      }
    }

    if (!deviceFound) {
      device = {
        "address": devicePB.address,
        "isMaster": devicePB.isMaster,
        "channel1": false,
        "channel2": false,
        "channel3": false,
        "channel4": false,
        "channel5": false
      };
    }

    return device;
  }

  handleSort = clickedColumn => () => {
    this.setState({
      isColumnClicked: true
    });

    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "channel1" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel1",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "channel1" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel1",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "channel2" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel2",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "channel2" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel2",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "channel3" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel3",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "channel3" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel3",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "channel4" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel4",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "channel4" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel4",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
    else if (clickedColumn === "channel5" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel5",
            false,
            function (a) { return a; })),
        sortDirection: "descending",
      });
    }
    else if (clickedColumn === "channel5" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "channel5",
            true,
            function (a) { return a; })),
        sortDirection: "ascending",
      });
    }
  }

  buildDeviceRows = (device) => {
    return (
      <Table.Row
        disabled={!this.state.isDeviceChannelsOn}
        key={device.address}
        textAlign="center"
        verticalAlign="middle">

        <Table.Cell width="1" verticalAlign="middle">
          {device.address}{UtilsInstance.getMasterSuffix(device.isMaster)}
        </Table.Cell>

        <Table.Cell width="1" verticalAlign="middle">
          <Checkbox
            checked={device.channel1}
            onChange={() => { this.toggleCheckbox(device.address, "channel1"); }} />
        </Table.Cell>

        <Table.Cell width="1" verticalAlign="middle">
          <Checkbox
            checked={device.channel2}
            onChange={() => { this.toggleCheckbox(device.address, "channel2"); }} />
        </Table.Cell>

        <Table.Cell width="1" verticalAlign="middle">
          <Checkbox
            checked={device.channel3}
            onChange={() => { this.toggleCheckbox(device.address, "channel3"); }} />
        </Table.Cell>

        <Table.Cell width="1">
          <Checkbox
            checked={device.channel4}
            onChange={() => { this.toggleCheckbox(device.address, "channel4"); }} />
        </Table.Cell>

        <Table.Cell width="1">
          <Checkbox
            checked={device.channel5}
            onChange={() => { this.toggleCheckbox(device.address, "channel5"); }} />
        </Table.Cell>

      </Table.Row>
    );
  }

  toggleCheckbox = (address, channel) => {
    let devicesCopy = JSON.parse(JSON.stringify(this.state.devices));

    for (let i = 0; i < devicesCopy.length; i++) {
      if (devicesCopy[i].address === address) {
        switch (channel) {
          case "channel1":
            devicesCopy[i]["channel1"] = !devicesCopy[i]["channel1"] ? true : true;
            devicesCopy[i]["channel2"] = false;
            devicesCopy[i]["channel3"] = false;
            devicesCopy[i]["channel4"] = false;
            devicesCopy[i]["channel5"] = false;
            break;
          case "channel2":
            devicesCopy[i]["channel1"] = false;
            devicesCopy[i]["channel2"] = !devicesCopy[i]["channel2"] ? true : true;
            devicesCopy[i]["channel3"] = false;
            devicesCopy[i]["channel4"] = false;
            devicesCopy[i]["channel5"] = false;
            break;
          case "channel3":
            devicesCopy[i]["channel1"] = false;
            devicesCopy[i]["channel2"] = false;
            devicesCopy[i]["channel3"] = !devicesCopy[i]["channel3"] ? true : true;
            devicesCopy[i]["channel4"] = false;
            devicesCopy[i]["channel5"] = false;
            break;
          case "channel4":
            devicesCopy[i]["channel1"] = false;
            devicesCopy[i]["channel2"] = false;
            devicesCopy[i]["channel3"] = false;
            devicesCopy[i]["channel4"] = !devicesCopy[i]["channel4"] ? true : true;
            devicesCopy[i]["channel5"] = false;
            break;
          case "channel5":
            devicesCopy[i]["channel1"] = false;
            devicesCopy[i]["channel2"] = false;
            devicesCopy[i]["channel3"] = false;
            devicesCopy[i]["channel4"] = false;
            devicesCopy[i]["channel5"] = !devicesCopy[i]["channel5"] ? true : true;
            break;
        }
      }
    }

    this.setState({ devices: devicesCopy });
  }

  // -----------------------------------------------------------------------
  sendData = () => {
    let route = "";
    let data = {};

    this.setState({
      isModalOpen: false,
      isUpdateLoaderDimmerActive: true
    }, () => {
      this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_WAITING, "");

      if (this.state.changeType === Constants.MANUAL_CHANNEL) {
        route = "devicesPerChannelOn_POST";
        data = { "isOn": !this.state.isDeviceChannelsOn };
      }
      else if (this.state.changeType === Constants.VERIFY_MASTER) {
        route = "verificarMestreDoSegmento_POST";
        data = { "checkMaster": !this.state.checkMaster };
      }
      else {
        route = "devicesPerChannel_POST";
        data = {
          "channel1": [],
          "channel2": [],
          "channel3": [],
          "channel4": [],
          "channel5": [],
        };

        for (let i = 0; i < this.state.devices.length; i++) {
          if (this.state.devices[i].channel1) {
            data.channel1.push(this.state.devices[i].address);
          }
          else if (this.state.devices[i].channel2) {
            data.channel2.push(this.state.devices[i].address);
          }
          else if (this.state.devices[i].channel3) {
            data.channel3.push(this.state.devices[i].address);
          }
          else if (this.state.devices[i].channel4) {
            data.channel4.push(this.state.devices[i].address);
          }
          else if (this.state.devices[i].channel5) {
            data.channel5.push(this.state.devices[i].address);
          }
        }
      }

      fetch(Constants.REQUEST_IP_ADDRESS + route, {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify(data)
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_WAITING_2, "");
          this.setState({ intervalID: setInterval(this.handleUpdateStatus, 2000) });
        })
        .catch((error) => {
          alert(Strings.SEND_CONFIG_FAILURE + "\n" + Strings.REASON_DP + error);
          this.setState({ isUpdateLoaderDimmerActive: false });
        });
    });
  }

  handleUpdateStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        let dataUpdate = (data.update === Constants.UPDATE_VERIFY_MASTER) || (data.update === Constants.UPDATE_DEVICES_CHANNEL) || (data.update === Constants.UPDATE_MANUAL_CHANNELS);
        let thisUpdateStatus = (this.state.updateStatus === Constants.UPDATE_VERIFY_MASTER) || (this.state.updateStatus === Constants.UPDATE_DEVICES_CHANNEL) || (this.state.updateStatus === Constants.UPDATE_MANUAL_CHANNELS);

        if (this.state.updateStatus === Constants.NOT_UPDATING && dataUpdate) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, Strings.RESTARTING_INTERNAL_PROCEDURES);
          });
        }
        else if (thisUpdateStatus && data.update === Constants.NOT_UPDATING) {
          this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, "");
          this.setState({
            updateStatus: data.update,
            isUpdateLoaderDimmerActive: false
          }, () => {
            clearInterval(this.state.intervalID);
            if (this.state.changeType == Constants.DEV_CHANNELS) {
              alert(Strings.DEVICES_PER_CHANNEL_POST_SUCCESS);
            }
            else if (this.state.changeType == Constants.MANUAL_CHANNEL) {
              alert(Strings.DEVICES_PER_CHANNEL_ON_POST_SUCCESS);
            }
            else {
              alert(Strings.VERIFY_MASTER_POST_SUCCESS);
            }
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        if (this.state.changeType == Constants.DEV_CHANNELS) {
          alert(Strings.DEVICES_PER_CHANNEL_POST_ERROR + Strings.ERROR_REASON + error);
        }
        else if (this.state.changeType == Constants.MANUAL_CHANNEL) {
          alert(Strings.DEVICES_PER_CHANNEL_ON_POST_ERROR + Strings.ERROR_REASON + error);
        }
        else {
          alert(Strings.VERIFY_MASTER_POST_ERROR + Strings.ERROR_REASON + error);
        }

        clearInterval(this.state.intervalID);
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    const messageVisibility = !this.state.isDeviceChannelsOn ? "visible" : "hidden";
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const deviceRows = this.state.devices.map(device => (this.buildDeviceRows(device)));

    return (
      <div style={configStyle}>
        <Grid columns={2}>
          <Grid.Row>

            <Grid.Column width={3}>
              <Segment style={segmentStyle}>
                <Divider style={dividerStyle} horizontal>
                  {Strings.MANUAL_CHANNEL_SELECTION_1} <br />
                  {Strings.MANUAL_CHANNEL_SELECTION_2}
                  <Popup position='right center' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.MANUAL_CHANNEL_SELECTION_POPUP_1}</p>
                      <p>{Strings.MANUAL_CHANNEL_SELECTION_POPUP_2}.</p>
                      <p><b>{Strings.PS}:</b> {Strings.MANUAL_CHANNEL_SELECTION_POPUP_3}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Checkbox
                  toggle
                  label={this.state.isDeviceChannelsOn ? Strings.DEVICE_CHANNELS_ON : Strings.DEVICE_CHANNELS_OFF}
                  onClick={() => {
                    this.showModal(
                      Strings.MANUAL_CHANNEL_SELECTION,
                      Strings.CHANGE_MANUAL_SELECTION_QUESTION_1,
                      Strings.CHANGE_MANUAL_SELECTION_QUESTION_2
                    );
                  }}
                  checked={this.state.isDeviceChannelsOn}
                />

                <Divider horizontal>
                  {Strings.CHECK_MASTER_2}
                  <Popup position='right center' hoverable pinned wide
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.CHECK_MASTER_POPUP}</p>
                    </Popup.Content>
                  </Popup>

                </Divider>
                <Checkbox
                  toggle
                  label={this.state.checkMaster ? Strings.DEVICE_CHANNELS_ON : Strings.DEVICE_CHANNELS_OFF}
                  onClick={() => {
                    this.showModal(
                      Strings.CHECK_MASTER_2,
                      Strings.CHANGE_VERIFY_MASTER_QUESTION_1,
                      Strings.CHANGE_VERIFY_MASTER_QUESTION_2
                    );
                  }}
                  checked={this.state.checkMaster}
                />
              </Segment>

              <Message info style={{ visibility: messageVisibility }}>
                <MessageHeader style={{ textAlign: "center" }}>{Strings.WARNING}</MessageHeader>
                <p>{Strings.MANUAL_SELECTION_WARNING_MESSAGE}</p>
              </Message>

            </Grid.Column>

            <Grid.Column width={13}>
              <Table striped celled textAlign="center" fixed sortable style={tableHeaderStyle}>
                <Table.Header>
                  <Table.Row disabled={!this.state.isDeviceChannelsOn}>
                    <Table.HeaderCell
                      width="1"
                      sorted={column === "address" ? direction : null}
                      onClick={this.handleSort("address")}>
                      {Strings.ADDRESS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width="1"
                      sorted={column === "channel1" ? direction : null}
                      onClick={this.handleSort("channel1")}>
                      {Strings.CHANNEL_1}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width="1"
                      sorted={column === "channel2" ? direction : null}
                      onClick={this.handleSort("channel2")}>
                      {Strings.CHANNEL_2}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width="1"
                      sorted={column === "channel3" ? direction : null}
                      onClick={this.handleSort("channel3")}>
                      {Strings.CHANNEL_3}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width="1"
                      sorted={column === "channel4" ? direction : null}
                      onClick={this.handleSort("channel4")}>
                      {Strings.CHANNEL_4}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width="1"
                      sorted={column === "channel5" ? direction : null}
                      onClick={this.handleSort("channel5")}>
                      {Strings.CHANNEL_5}
                    </Table.HeaderCell>

                  </Table.Row>
                </Table.Header>
              </Table>

              <div style={tableStyle}>
                <Table striped celled textAlign="center" fixed>
                  <Table.Body>{deviceRows}</Table.Body>
                </Table>
              </div>

              <Button
                disabled={!this.state.isDeviceChannelsOn}
                style={buttonStyle}
                fluid
                color="teal"
                content={Strings.UPDATE}
                onClick={() => {
                  this.showModal(
                    Strings.ALTER_DEVICES_CHANNELS,
                    Strings.CHANGE_DEVICES_CHANNEL_QUESTION_1,
                    Strings.CHANGE_DEVICES_CHANNEL_QUESTION_2
                  );
                }} />

            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Modal style={modalStyle} centered open={this.state.isModalOpen} size='small'>
          <Header content={this.state.modalHeader} />
          <Modal.Content>
            <p>{this.state.modalText1}</p>
            <p>{this.state.modalText2}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.sendData}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={this.state.isUpdateLoaderDimmerActive} >
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </div>
    );
  }
}

const segmentStyle = {
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

const tableStyle = {
  overflowY: "scroll",
  maxHeight: "60vh"
};

const tableHeaderStyle = {
  width: "99.5%"
};

const configStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const buttonStyle = {
  marginTop: "2vh"
};

const dividerStyle = {
  marginTop: "-0.2vh",
  marginBottom: "0.5vh"
};

const modalStyle = {
  width: "800px",
  height: "245px",
  margin: "20vh auto"
};

export default withRouter(DevicesChannels);